<template>
  <div class="upload-image" @click.stop="uploadImage">
    <div class="upload-box" v-if="!Boolean($slots.default)">
      <div class="upload-icon">
        <i class="iconfont icon-tianjia"></i>
      </div>
      <div class="upload-desc">上传图片</div>
    </div>
    <template v-else>
      <slot></slot>
    </template>
    <input
      ref="uploadImage"
      style="display: none;"
      :multiple="multiple"
      type="file"
      accept="Image/*"
      @change="uploadFile"
      @click.stop="() => {}"
    />
    <el-dialog title="编辑图片" append-to-body width="400px" :visible.sync="dialogVisible" :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="50px">
        <el-form-item label="url">
          <el-input v-model="form.url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleUpload">手动上传</el-button>
        <el-button type="primary" @click="handleEdit">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// upload
import { uploadFile } from "@/plugins/uploadFile";
// element-ui
import { Message } from "element-ui";
import ProgressBar from "../ProgressBar";

export default {
  name: "UploadImage",
  components: {
    ProgressBar
  },
  props: {
    type: {
      type: String,
      default: "add"
    },
    data: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadProgressList: [],
      dialogVisible: false,
      form: {
        url: ""
      }
    };
  },

  mounted() {},

  methods: {
    uploadImage() {
      if (this.type == "edit") {
        this.dialogVisible = true;
        this.form.url = this.data;
        return;
      }
      this.$refs.uploadImage.click();
    },
    handleUpload() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.$refs.uploadImage.click();
      });
    },
    handleEdit() {
      this.dialogVisible = false;
      this.$emit("onImageUploaded", [this.form.url]);
    },
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        url: ""
      };
    },
    renderProgress() {
      const h = this.$createElement;
      const progressVdomList = this.uploadProgressList.map((item, index) => {
        return h("ProgressBar", {
          ref: "progress_" + index,
          key: index,
          props: {
            name: item.file.name,
            percentage: parseInt(item.percent) || 0
          }
        });
      });

      this.$notify({
        title: "上传中",
        message: h("div", { style: { width: "280px" } }, progressVdomList),
        duration: 0
      });
    },
    async uploadFile(e) {
      const files = e.target.files;
      console.log(e.target, files);
      if (files.length === 0) return;

      try {
        let uploadlist = [];
        for (let i = 0; i < files.length; i++) {
          this.uploadProgressList.push({
            file: files[i],
            percent: 0
          });
          uploadlist.push(this.uploadImgFile(files[i], i));
        }
        console.log(this.uploadProgressList);
        // 上传进度
        this.renderProgress();

        const urlList = await Promise.all(uploadlist);
        // 关闭上传进度
        setTimeout(() => {
          this.$notify.closeAll();
        }, 3000);

        const filterUrlList = urlList.filter(src => src !== "error");
        if (filterUrlList.length > 0) {
          this.$emit("onImageUploaded", filterUrlList);
        }
      } catch (error) {
        console.log(error);
      } finally {
        // 重置上传器
        this.$refs.uploadImage.value = "";
      }
    },
    async uploadImgFile(file, index = 0) {
      try {
        let params = {
          file: file,
          width: 0,
          height: 0,
          url: "",
          localImgUrl: "",
          percent: 0,
          text: "",
          waterMark: this.uploadType,
          isDelete: false,
          progressCb: percent => {
            console.log(percent);
            setTimeout(() => {
              params.percent = percent;
              this.$refs["progress_" + index].setPercentage(parseInt(percent));
              if (percent == 100) {
                this.$refs["progress_" + index].setStatus("success");
              }
            }, 500);
          }
        };
        // console.log(params);
        const res = await uploadFile(params);
        const url = res.url;
        return url;
      } catch (error) {
        Message({
          message: "图片上传错误！",
          type: "error"
        });
        this.$refs["progress_" + index].setStatus("exception");
        console.log(error);
        return "error";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.upload-image {
  width: 100%;
  height: 100%;
  cursor: pointer;
  vertical-align: top;
  border-radius: inherit;
  .upload-box {
    width: 100%;
    height: 100%;
    background: #727c86;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: inherit;
  }
  .upload-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
    text-align: center;
    line-height: 32px;
    font-size: 18px;
    margin-bottom: 12px;
    color: #fff;
  }
  .upload-desc {
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}
</style>
